<template>
  <div class="input-container">
    <legend>{{ legend }}</legend>

    <input type="month" class="input" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)"
      :disabled="disabled" />
  </div>
</template>

<script>

export default {
  name: 'InputMonth',
  props: {
    legend: {
      type: String,
      required: true,
    },
    modelValue: {
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.input-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  legend {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #606264;
    line-height: 21.82px;
  }

  .input {
    height: 2.738125rem;
    outline: 0;
    padding: 0.625rem;
    border: 1px solid #EAEAEA;
    border-radius: 4px;
    font-size: 1rem;
    font-weight: 600;
    line-height: 21.82px;
  }
}
</style>